import type { SiteWithApis } from '@/stores';
import { InventorySiteSection } from '@/types.ts';

/** Pick the site tab matching the current site (by id, then name), or the first tab. */
export const resolvePreferredSiteSection = (
  siteSections: readonly InventorySiteSection[],
  currentSite: SiteWithApis | undefined,
  sites: readonly SiteWithApis[]
): InventorySiteSection | undefined => {
  if (!siteSections.length) return undefined;

  const site = currentSite ?? sites[0];
  if (!site) return siteSections[0];

  return (
    siteSections.find(section => site.id === section.siteId) ??
    siteSections.find(section => section.siteTitle === site.name) ??
    siteSections[0]
  );
};
